import { CustomTable, ETypeOfNotification, formatCurrency, Notification, NotificationRef, Steps } from 'medere-ui-framework'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { useRef } from 'react'
import { usePaymentOrder } from '../../components/context/PaymentOrderContext'
import PaymentOrderHeader from './PaymentOrderHeader'
import TaxTypesComponent from '../Tax/TaxTypesComponents'
import { OperationType } from '../../interface/interface'


interface HoldbacksProps {
}

const Holdbacks = ({ }: HoldbacksProps) => {
    const { stepMovement, invoices, steps, paymentArray, totalToPay, setTotalToPay} = usePaymentOrder()
    const notificationRef = useRef<NotificationRef>(null)
    const {paidTaxes, addPaidTax, removePaidTax,supplier, totalWithoutTaxes, earningWithHoldingConcept, setEarningWithHoldingConcept} = usePaymentOrder()


    function isTotalToPayExceeded() {
        // Cuando el total a pagar es menor a 0, se excede el monto total
        return totalToPay.lt(0)
    }

    function nextStep() {
        if (isTotalToPayExceeded()) {
            notificationRef?.current?.notify({ title: "Error en el total", desc: "El total a pagar no puede ser menor a 0", typeOfNotification: ETypeOfNotification.ERROR })
            return
        }
        stepMovement.nextStep()
    }

    return (
        <>
            <Steps steps={steps} activeStep={stepMovement.stepIndex} labelStyle={{ color: '#01717C', fontSize: '16px', fontWeight: '500' }} />
            <PaymentOrderHeader className='mb-3' />
            <CustomTable
                idTable="holdbacksTable"
                hideFiltersButton
                getItems={() => Promise.resolve(invoices)}
                notFlex
                className="mb-4"
            >
                <Column header='Fecha' field="date" body={(e) => new Date(e.date).toLocaleDateString()} />
                <Column header='Tipo' field="receipttype" />
                <Column header='N' field="formnumber" />
                <Column header='Concepto' field='observations' />
                <Column header='Sucursal' field="posnumber" />
                <Column header="Importe" field="amount" body={(e) => {
                    if (e.amount) {
                        return <div className="flex flex-column gap-3">
                            <p>{`${formatCurrency(Number(e.amount?.toFixed(2)), {
                                currency: 'ARS',
                            })}`}</p>
                        </div>
                    }
                    return ''
                }} />
                <Column header='A pagar' body={(e) => {
                    const item = paymentArray.find((i) => i.orderId == `${e.posnumber}|${e.formnumber}` && i.paymentValue === e.amount)
                    if (item) {
                        return <p className='font-bold'>{`${formatCurrency(Number(item.paymentToPay?.toFixed(2)), {
                            currency: 'ARS',
                        })}`}</p>
                    }
                }} />
                <Column header='Vencimiento' />
            </CustomTable>

            <TaxTypesComponent
                operationType={OperationType.FOR_PAYMENTS_TO_OTHERS} earningWithHoldingConcept={earningWithHoldingConcept} setEarningWithHoldingConcept={setEarningWithHoldingConcept} paidTaxes={paidTaxes} addPaidTax={addPaidTax} removePaidTax={removePaidTax} supplier={supplier} totalWithoutTaxes={totalWithoutTaxes} totalToPay={totalToPay} setTotalToPay={setTotalToPay}            
            />
            <div className="flex flex-end align-items-center">
                <Button className="buttonMain2 capitalize" label="volver" iconPos="left" icon="pi pi-chevron-left" onClick={stepMovement.prevStep} />
                <Button className="buttonMain capitalize" label="seguir" iconPos="right" icon="pi pi-chevron-right" onClick={nextStep} />
            </div>
            <Notification ref={notificationRef} />
        </>
    )
}

export default Holdbacks
